module.exports = __webpack_public_path__ + "static/media/logo_login1.c11609cb.png";